import { BATTLESHIP, CANDY_APPLE_MEDIUM, MARIGOLD, OZ_MEDIUM } from 'HubStyleTokens/colors';
export const convertUseToRingColor = use => {
  switch (use) {
    case 'high':
      return OZ_MEDIUM;
    case 'mid':
      return MARIGOLD;
    case 'low':
      return CANDY_APPLE_MEDIUM;
    case 'none':
      return BATTLESHIP;
    default:
      return BATTLESHIP;
  }
};
export const formatScoreValue = value => {
  return Math.floor(value);
};